var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgenda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.59359V1.26025V2.59359ZM9 2.59359V3.92692V2.59359ZM9 2.59359H6H9ZM1 6.59359V12.5936C1 12.9472 1.14048 13.2863 1.39052 13.5364C1.64057 13.7864 1.97971 13.9269 2.33333 13.9269H11.6667C12.0203 13.9269 12.3594 13.7864 12.6095 13.5364C12.8595 13.2863 13 12.9472 13 12.5936V6.59359H1Z",
    stroke: "#717A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.59375V3.92708C1 3.57346 1.14048 3.23432 1.39052 2.98427C1.64057 2.73423 1.97971 2.59375 2.33333 2.59375H3.66667",
    stroke: "#717A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 1.26025V3.92692V1.26025Z",
    fill: "#717A97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66663 1.26025V3.92692",
    stroke: "#717A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.59375V3.92708C13 3.57346 12.8596 3.23432 12.6095 2.98427C12.3595 2.73423 12.0203 2.59375 11.6667 2.59375H11.3334",
    stroke: "#717A97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.27ebc741f16551465e92306667de9c86.svg";
export { ForwardRef as ReactComponent };